import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Heading, ChevronUpIcon, ChevronDownIcon } from '@elseu/sdu-titan';
import { useState, useEffect, Fragment } from 'react';
import styled from 'styled-components';
import { createSlug } from '../../utilities/createSlug/createSlug.js';

var StyledAccordion = styled.dl(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Header = styled.dt(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: ", ";\n  padding: ", ";\n  padding-left: 0;\n\n  ", ";\n"], ["\n  cursor: pointer;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: ", ";\n  padding: ", ";\n  padding-left: 0;\n\n  ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[4];
}, function (_a) {
  var theme = _a.theme;
  return theme.spacing[6];
}, function (_a) {
  var isOpen = _a.isOpen,
    theme = _a.theme;
  return isOpen ? "\n      padding-bottom: 0;\n  " : "\n    border-bottom: 1px solid ".concat(theme.designTokens.colors.secondary30, ";\n  ");
});
var Content = styled.dd(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  overflow: hidden;\n  transition: max-height 0.3s ease-out;\n  margin: 0;\n  padding-right: ", ";\n\n  ", ";\n"], ["\n  overflow: hidden;\n  transition: max-height 0.3s ease-out;\n  margin: 0;\n  padding-right: ", ";\n\n  ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[6];
}, function (_a) {
  var isOpen = _a.isOpen,
    theme = _a.theme;
  return isOpen ? "\n    max-height: none;\n    border-bottom: 1px solid ".concat(theme.designTokens.colors.secondary30, ";\n  ") : "\n    max-height: 0;\n  ";
});
var IconWrapper = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
/**
 * Creates a URL hash from the given header string.
 *
 * @param {string} header - The input header string to be converted into a URL hash.
 * @returns {string} - The constructed URL hash.
 */
var createHash = function (header) {
  return "q-".concat(createSlug(header));
};
/**
 * An Accordion component that displays multiple items.
 *
 * @param {AccordionProps} props - The props for the Accordion component.
 * @returns {JSX.Element} The Accordion component.
 */
var Accordion = function (_a) {
  var items = _a.items,
    className = _a.className;
  var _b = useState(null),
    activeIndex = _b[0],
    setActiveIndex = _b[1];
  /**
   * Toggles the visibility of an accordion item.
   *
   * @param {number} index - The index of the accordion item to toggle.
   * @returns {void}
   */
  var handleToggleAccordion = function (index) {
    setActiveIndex(function (previous) {
      var newIndex = previous === index ? null : index;
      var _a = window.location,
        pathname = _a.pathname,
        search = _a.search;
      /* Update the URL hash when an accordion item is opened */
      var hash = newIndex !== null ? "#".concat(createHash(items[newIndex].header)) : '';
      window.history.replaceState(null, '', "".concat(pathname).concat(search).concat(hash));
      return newIndex;
    });
  };
  /**
   * Handles keydown events for the accordion items.
   *
   * @param {React.KeyboardEvent<HTMLElement>} event - The keyboard event.
   * @param {number} index - The index of the accordion item.
   * @returns {void}
   */
  var handleKeyDown = function (_a, index) {
    var key = _a.key;
    if (key === 'Enter' || key === ' ') {
      handleToggleAccordion(index);
    }
  };
  /**
   * Handles URL hash changes to synchronize with accordion state.
   */
  useEffect(function () {
    var hash = window.location.hash;
    if (hash) {
      /* Find the accordion item index that corresponds to the URL hash */
      var index = items.findIndex(function (_a) {
        var header = _a.header;
        return "#".concat(createHash(header)) === hash;
      });
      /* If an item matches the hash, set it as active and scroll to it */
      setActiveIndex(index >= 0 ? index : null);
      var targetElement = document.querySelector(hash);
      targetElement === null || targetElement === void 0 ? void 0 : targetElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [items]);
  return jsx(StyledAccordion, {
    className: className,
    children: items.map(function (_a, index) {
      var header = _a.header,
        content = _a.content;
      var isOpen = activeIndex === index;
      return jsxs(Fragment, {
        children: [jsxs(Header, {
          onClick: function () {
            return handleToggleAccordion(index);
          },
          onKeyDown: function (event) {
            return handleKeyDown(event, index);
          },
          tabIndex: 0,
          "aria-expanded": isOpen,
          isOpen: isOpen,
          "aria-controls": "accordion-".concat(index, "-content"),
          id: createHash(header),
          children: [jsx(Heading, {
            heading: "h5",
            renderAs: "span",
            children: header
          }), jsx(IconWrapper, {
            children: isOpen ? jsx(ChevronUpIcon, {}) : jsx(ChevronDownIcon, {})
          })]
        }), jsx(Content, {
          isOpen: isOpen,
          id: "accordion-".concat(index, "-content"),
          "aria-hidden": activeIndex !== index,
          children: content
        })]
      }, header);
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { Accordion };
//# sourceMappingURL=Accordion.js.map
